module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C841"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("POS")]), _vm._v("SIBLE PSALM")])]), _vm._v(" "), _c('p', {
    staticClass: "C852"
  }, [_vm._v("When I saw light the sculptor chiseling sheer bluff")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("from slope—the cleaved wood landing as shadow")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("in down-mountain saddles, a coarse grit teasing out")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("the basalt’s facelike features, then finer grains")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("crazing the air with duff—")]), _vm._v(" "), _c('p', {
    staticClass: "C852"
  }, [_vm._v("I said aloud "), _c('em', [_vm._v("good light:")]), _vm._v(" as if it were dog or obedient")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("child, as if there were some other kind. As if it had not by then")]), _vm._v(" "), _c('p', {
    staticClass: "C854"
  }, [_vm._v("vanished into that antipodal room, the work shrouded in dark sheet.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2211b676","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/08_Possible.vue
// module id = 78
// module chunks = 0